import { Button } from "@mui/material";
import React from "react";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import "./CustomButton.css";

interface CustomButtonProps {
  toDisplay: string;
  logo: string;
  icon: React.ReactNode;
  link: string;
}
const CustomButton: React.FC<CustomButtonProps> = ({
  toDisplay,
  logo,
  icon,
  link,
}) => {
  return (
    <a href={link} target="_blank" rel="noreferrer">
      <Button
        className="custom-button"
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={
          logo!=='' ?
          <img
            src={logo}
            alt="Doctolib, Nawel BOUCHOUKH, Psychologue clinicienne, TCC, PARIS, Villejuif"
            style={{ width: 24, height: 24 }}
          />
          :
          null
        }
        endIcon={icon}
      >
        {toDisplay}
      </Button>
    </a>
  );
};

export default CustomButton;
